import Analytics from "src/composables/Analytics";

export default ({ router }) => {
    const { log_page } = Analytics();
    router.afterEach((to, from) => {
        log_page({ name: to.name, path: to.path })
    })
}
